/** Primary hub scrollport — set on `PrimaryPageTemplate` body wrapper in apps/web. */
export const PAGE_SCROLL_ATTR = "data-page-scroll"

/** Breadcrumb / site chrome — bottom edge is the table sticky-header pin line. */
export const SITE_HEADER_ATTR = "data-site-header"

/**
 * The element that vertically scrolls hub page content (not `window`).
 * Falls back to `#main-content` for legacy shells.
 */
export function getPageScrollElement(): HTMLElement | null {
  if (typeof document === "undefined") return null
  return (
    document.querySelector<HTMLElement>(`[${PAGE_SCROLL_ATTR}]`) ??
    document.getElementById("main-content")
  )
}

/**
 * Viewport Y where floating table column headers should pin — bottom of
 * `SiteHeader` when present, else `--header-height` (48px).
 */
export function getStickyTableHeaderOffset(): number {
  if (typeof document === "undefined") return 48

  const siteHeader = document.querySelector<HTMLElement>(`[${SITE_HEADER_ATTR}]`)
  if (siteHeader) {
    const { bottom } = siteHeader.getBoundingClientRect()
    if (bottom > 0) return bottom
  }

  const rootStyle = getComputedStyle(document.documentElement)
  return Number.parseFloat(rootStyle.getPropertyValue("--header-height")) || 48
}

/** Subscribe to vertical scroll sources that move tables relative to the viewport. */
export function bindVerticalScrollListeners(onScroll: () => void): () => void {
  const handler = () => onScroll()

  window.addEventListener("scroll", handler, { passive: true })
  window.addEventListener("resize", handler, { passive: true })

  const pageScroll = getPageScrollElement()
  pageScroll?.addEventListener("scroll", handler, { passive: true })

  return () => {
    window.removeEventListener("scroll", handler)
    window.removeEventListener("resize", handler)
    pageScroll?.removeEventListener("scroll", handler)
  }
}
